// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentNetStandardCaseRelationshipsModel {
    static getAttributeTypeMap() {
        return EnrollmentNetStandardCaseRelationshipsModel.attributeTypeMap;
    }
}
EnrollmentNetStandardCaseRelationshipsModel.discriminator = undefined;
EnrollmentNetStandardCaseRelationshipsModel.additionalProperties = false;
EnrollmentNetStandardCaseRelationshipsModel.attributeTypeMap = [
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": ""
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": ""
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": ""
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": ""
    },
];
//# sourceMappingURL=enrollmentNetStandardCaseRelationshipsModel.js.map